<template>
  <div>
    <vxe-modal
        v-model="isShow"
        width="1200"
        height="600"
        resize
        remember
        :title="isEdit ? '编辑' : '创建'"
    >
      <div class="add-box clearfix" style="margin-bottom: 50px;">
        <table-header @add="insertEvent" @remove="removeEvent" @copy="copyEvent" v-if="!isEdit"></table-header>
        <vxe-table
            border
            show-overflow
            keep-source
            class="table-style"
            ref="xTable"
            highlight-hover-row
            max-height="440"
            :data="tableData"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'cell' }"
            @scroll="$refs.xTable.clearValidate()"
        >
          <vxe-table-column align="center" type="checkbox" width="40" v-if="!isEdit"></vxe-table-column>
          <vxe-table-column
              type="seq"
              width="60"
              align="center"
              title="序号"
          ></vxe-table-column>
          <vxe-table-column field="replaceTaxpayer" title="纳税人名称" width="120">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <div class="link-text" @click="openChoosePerson(row, 'replaceTaxpayer')">
                {{ row.replaceTaxpayer ? row.replaceTaxpayer : "请选择" }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="repalceTaxNum" title="纳税人证件号码" width="150">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.repalceTaxNum" placeholder="选填" maxlength="200"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="taxId" title="所属税务机关" width="200">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <!--              <Select v-model="row.taxId">-->
              <!--                <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>-->
              <!--              </Select>-->
              <vxe-select v-model="row.taxId" :options="taxList" placeholder="请选择税务机关" transfer></vxe-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="addTime" title="日期" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.addTime" type="date" placeholder="请选择"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="belongTime" title="税款所属时间" show-overflow width="200">
            <template v-slot="{ row }">
              <vxe-input v-model="row.belongTime" @click="openDateRange(row)" placeholder="请选择"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="addTax" title="增值税" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.addTax" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="localEduAdd" title="地方教育附加" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.localEduAdd" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="eduSurcharge" title="教育费附加" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.eduSurcharge" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="constructionTax" title="城市维护建设税" show-overflow width="140">
            <template v-slot="{ row }">
              <vxe-input v-model="row.constructionTax" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="individualTax" title="个人所得税" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.individualTax" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="stampTax" title="印花税" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.stampTax" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ortherTax" title="其它" show-overflow width="120">
            <template v-slot="{ row }">
              <vxe-input v-model="row.ortherTax" placeholder="选填" type="number" maxlength="16"></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fileList" title="完税证明" align="center" width="150">
            <template v-slot="{ row }">
              <upload-list
                  :row="row"
                  :initFileList="row.fileList"
                  ref="uploadlistbox"
                  :view="'packup'"
                  :maxLength="1"
              ></upload-list>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div class="footer-wrap">
          <Button type="primary" @click="submitEvent('new')">提 交</Button>
        </div>
      </div>
    </vxe-modal>

    <vxe-modal
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择客户"
    >
      <account @choose="chooseAccountEvent" ref="chooseAccount"></account>
    </vxe-modal>

    <vxe-modal class="timeModal" title="选择时间" v-model="open" width="460" height="380" :show-footer="false"
               :showHeader="true">
      <template v-slot>
        <DatePicker
            v-model="dateRangeTime"
            :open="open"
            confirm
            type="daterange"
            :split-panels="true"
            placeholder
            style="width: 432px"
            @on-change="handleChange"
            @on-clear="handleClear"
            @on-ok="handleOk"
        >
          <span class="date-slot"></span>
        </DatePicker>
      </template>
    </vxe-modal>

  </div>
</template>

<script>
import {
  assign,
  hideLoading,
  isEmpty,
  isNotEmpty,
  showError,
  showFailMsgList,
  showLoading,
  showSuccess, sleep
} from "@/utils/util";
import {apiPost} from "@/utils/api";
import TableHeader from "@/components/common/TableHeader";
import Account from "@/components/modal/InvoiceAccount";
import UploadList from "@/components/common/UploadList";
import $api from "@/apiProvider";


export default {
  name: "AddInvoiceReplace",
  components: {TableHeader, Account, UploadList},
  data() {
    return {
      isEdit: false,
      isShow: false,
      isShowChooseAccount: false,
      currentRow: null,
      tableData: [],
      editRules: {
        "replaceTaxpayer": [{
          validator: this.requireValid
        }],
        "repalceTaxNum": [{
          validator: this.requireValid
        }],
        "taxId": [{
          validator: this.requireValid
        }]
      },
      dataTmp: {
        id: null,
        replaceTaxpayer: null,
        repalceTaxNum: null,
        taxpayerId: null,
        addTime: null,
        belongTime: null,
        belongBeginTime: null,
        belongEndTime: null,
        addTax: null,
        localEduAdd: null,
        eduSurcharge: null,
        constructionTax: null,
        individualTax: null,
        stampTax: null,
        totalTax: null,
        ortherTax: null,
        fileUuidList: null,
        fileList: null,
        taxId: null
      },
      yearList: [],
      open: false,
      dateRangeTime: null,
      taxList: [],
    }
  },
  mounted() {
    this.getTaxList();
  },
  methods: {
    async getTaxList() {
      let res = await $api.tax.post('getTaxList', {});
      if (res.status === 1) {
        this.taxList = [];
        res.data.map(i => {
          this.taxList.push({
            label: i.taxComp,
            value: i.id
          })
        })
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async requireValid(e) {
      if (isEmpty(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + '必填'))
      }
    },
    async show(isEdit, editRow) {
      this.tableData = []
      if (this.$refs.xTable) {
        this.$refs.xTable.getTableData().tableData = []
        this.$refs.xTable.clearValidate()
      }
      this.isEdit = isEdit
      if (isEdit) {
        let row = assign(editRow)
        if (isNotEmpty(row.belongBeginTime) && isNotEmpty(row.belongEndTime)) {
          row.dateRangeTime = [new Date(row.belongBeginTime), new Date(row.belongEndTime)];
          row.belongTime = this.$utils.toDateString(row.dateRangeTime[0], 'yyyy-MM-dd')
              + ' 至 ' + this.$utils.toDateString(row.dateRangeTime[1], 'yyyy-MM-dd')
        }
        if (isNotEmpty(row.addTime)) {
          row.addTime = new Date(row.addTime);
        }
        this.tableData = [assign(row)]
      } else {
        this.isEdit = false
        this.tableData = [assign(this.dataTmp)];
      }
      this.isShow = true
      this.$refs.xTable.getTableData().tableData = this.tableData
      this.insertEvent()
    },
    openDateRange(row) {
      this.currentRow = row
      this.dateRangeTime = ['', '']
      if (isNotEmpty(row.belongBeginTime) && isNotEmpty(row.belongEndTime)) {
        this.dateRangeTime = [new Date(row.belongBeginTime), new Date(row.belongEndTime)]
      }
      this.open = true;
    },
    handleChange() {

    },
    handleClear() {

    },
    handleOk() {
      console.log(this.dateRangeTime)
      if (isEmpty(this.dateRangeTime[0]) || isEmpty(this.dateRangeTime[1])) {
        showError("没有选择时间")
        return
      }

      this.currentRow.belongBeginTime = this.$utils.timestamp(this.dateRangeTime[0])
      this.currentRow.belongEndTime = this.$utils.timestamp(this.dateRangeTime[1])

      this.currentRow.belongTime = this.$utils.toDateString(this.dateRangeTime[0], 'yyyy-MM-dd')
          + ' 至 ' + this.$utils.toDateString(this.dateRangeTime[1], 'yyyy-MM-dd')

      this.open = false
    },
    openChoosePerson(row) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.$refs.chooseAccount.initAccount(1, 1);
    },
    chooseAccountEvent(account, type) {
      console.log("chooseAccountEvent", account);
      this.currentRow['taxpayerId'] = account.id;
      this.currentRow['replaceTaxpayer'] = account.realName;
      this.currentRow['repalceTaxNum'] = account.idcardNum;
      this.$refs.xTable.clearValidate("repalceTaxNum");
      this.isShowChooseAccount = false;
    },
    insertEvent() {
      let tableData = this.$refs.xTable.getTableData().tableData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条",
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable.insertAt(checkboxRecords, -1);
    },
    async validEvent() {
      let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    async submitEvent() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return
      }
      let param = [];
      this.tableData = this.$refs.xTable.getTableData().tableData
      if (this.isEdit) {
        param = assign(this.tableData[0])
        if (isEmpty(param.addTax) && isEmpty(param.localEduAdd) && isEmpty(param.eduSurcharge)
            && isEmpty(param.constructionTax) && isEmpty(param.individualTax)
            && isEmpty(param.stampTax) && isEmpty(param.ortherTax)) {
          showError("请添写某一项税收金额")
          return
        }
        if (isNotEmpty(param.addTime)) {
          param.addTime = this.$utils.timestamp(this.$utils.toStringDate(param.addTime, "yyyy-MM-dd"));
        }
        showLoading();
        let res = await apiPost("api/order/", "twoReport/updateInvoiceReplace", param);
        hideLoading()
        if (res.status == 1) {
          showSuccess("保存成功")
          await sleep(1000)
          this.tableData = []
          this.isShow = false;
          this.$emit("success")
        } else if (res.message) {
          showError(res.message)
        } else {
          showError("服务端错误")
        }
      } else {
        let errorMsg = ''
        this.tableData.forEach(item => {
          if (isEmpty(item.addTax) && isEmpty(item.localEduAdd) && isEmpty(item.eduSurcharge)
              && isEmpty(item.constructionTax) && isEmpty(item.individualTax)
              && isEmpty(item.stampTax) && isEmpty(item.ortherTax)) {
            errorMsg = errorMsg + '序号' + (this.tableData.indexOf(item) + 1) + "请添写某一项税收金额 <br/>"
          }
          let d = assign(item)
          if (isNotEmpty(d.addTime)) {
            d.addTime = this.$utils.timestamp(this.$utils.toStringDate(d.addTime, "yyyy-MM-dd"));
          }
          param.push(d)
        })
        if (isNotEmpty(errorMsg)) {
          showError(errorMsg)
          return
        }
        showLoading();
        let res = await apiPost("api/order/", "twoReport/createInvoiceReplace", param);
        hideLoading()
        if (res.status == 1) {
          showSuccess("提交成功")
          await sleep(1000)
          this.isShow = false;
          this.$emit("success")
        } else if (res.message) {
          showError(res.message)
        } else if (isNotEmpty(res.data)) {
          showFailMsgList(res.data)
        } else {
          showError("服务端错误")
        }
      }
    },
  }
}
</script>

<style scoped>

</style>